module.exports = __webpack_public_path__ + "media/src/web/images/one-time-offer/right_woman-cb1606b741f70a1d486d6dff4a542815.png";